import { ShapeDiverValue } from '../../shape-diver';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { Parameter } from 'shapediver-types';

type ParameterDefinition = Parameter.ParameterDefinition;

export function useModelValue(paramName: string): ShapeDiverValue | undefined {
  return useSelector((root: RootState) => {
    const { parameters } = root.model;
    const { values } = root;

    const definition = parameters.find((p) => p.name === paramName);
    if (!definition || definition.id === undefined) return undefined;

    return values[definition.id];
  });
}

export function useModelDefinition(
  paramName: string
): ParameterDefinition | undefined {
  return useSelector((root: RootState) => {
    return root.model.parameters.find((p) => p.name === paramName);
  });
}
